module.exports = __webpack_public_path__ + "img/029-application-1.5a1f194c.png";